import styled from 'styled-components';
import { Card } from '@sainsburys-tech/luna-react';
import { ThemeColors } from 'src/shared/styles/variables';

export const AccountCardWrapper = styled((props: any) => <Card {...props} />)`
  padding: 48px;
  margin-top: 58px;

  .details-heading {
    font-family: var(--ds-font-stack-display-2-font-family) !important;
    font-style: normal;
    font-weight: 800;
    font-size: 22px;
    line-height: 24px;
    color: #404040;
    margin-bottom: 24px;

    display: flex;
    button {
      margin-left: auto;
    }
  }

  .section {
    &:not(:last-of-type) {
      padding-bottom: 24px;
      border-bottom: 1px solid ${ThemeColors.sectionSeparator};
    }
  }

  .section-detail {
    .section-label {
      font-family: var(--ds-font-stack-display-2-font-family) !important;
      font-weight: 800;
      font-size: 16px;
      line-height: 24px;
      color: ${ThemeColors.monochromeDark};
      width: 234px;
    }
  }

  .section-actions {
    margin-top: 8px;
    display: flex;
    align-items: center;
    justify-content: flex-end;

    .ln-c-button {
      margin-left: 24px;
    }
  }

  .account-details {
  }

  .roles-section {
  }

  option[value=''] {
    display: none;
  }

  .no-account-selected {
    text-align: center;
    padding-top: 64px;
  }
`;
